import React, {Fragment} from 'react';

import {ProcessTaskCore} from 'sweet-taskinfo/dist';

import {FullHTMLLink} from 'app/components/general/FullHTMLLink';
import {PrintTaskButton} from 'app/procedures/components/PrintTaskButton';
import {ProcedureHeaderOptionsDropdown} from 'app/procedures/components/ProcedureHeaderOptionsDropdown';
import {getContentType} from 'app/utils/content-type';
import {gt} from 'app/utils/i18n';
import {capitalizeFirstLetter} from 'app/utils/strings';

import type {ProcedureTaskCore} from 'sweet-taskinfo';
import type {ProcedureSerializedType, ProcessSerializedType} from 'sweet-types';

interface Props {
  taskCore: ProcedureTaskCore | ProcessTaskCore;
  object: ProcedureSerializedType | ProcessSerializedType;
  numCollapsedSteps?: number;
  stepsLength: number;
  onToggleAllStepsCollapse?: (collapsed: boolean) => void;
}

export function TaskPageActionButtons({
  taskCore,
  object,
  numCollapsedSteps,
  stepsLength,
  onToggleAllStepsCollapse,
}: Props): JSX.Element {
  const ct = getContentType(
    taskCore.ct === 'process' ? 'proceduregroup' : taskCore.ct
  );
  const docType = capitalizeFirstLetter(ct.name);

  return (
    <form className="form-inline d-print-none flex-nowrap">
      {taskCore.hasVersion ? (
        <Fragment>
          <ProcedureHeaderOptionsDropdown
            stepsLength={stepsLength}
            hideAdvancedMode={true}
            numCollapsedSteps={numCollapsedSteps}
            onToggleAllStepsCollapse={onToggleAllStepsCollapse}
          />
          &nbsp;
          {taskCore.task.assigned_version_content ? (
            <PrintTaskButton
              objectId={taskCore.task.assigned_version_content.id as number}
              canEdit={object.can_export}
              contentType={taskCore.task.assigned_version_content.content_type}
              addToPayload={{
                taskinstance: taskCore.task.url,
              }}
            />
          ) : null}
          &nbsp;
        </Fragment>
      ) : null}
      <FullHTMLLink className="btn btn-light btn-sm" html_url={object.html_url}>
        {gt('View %(docType)s', {docType})} <i className="fa fa-caret-right" />
      </FullHTMLLink>
    </form>
  );
}
